import script from "./addClass.vue?vue&type=script&setup=true&lang=js"
export * from "./addClass.vue?vue&type=script&setup=true&lang=js"

import "./addClass.vue?vue&type=style&index=0&id=67c607fd&lang=scss&scoped=true"

import exportComponent from "E:\\vue\\hxdh-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c607fd"]])

export default __exports__